import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-hover group" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row gap-4" }
const _hoisted_3 = { class: "sm:w-36 flex-shrink-0" }
const _hoisted_4 = { class: "text-xs font-medium text-stone-500 dark:text-stone-500 tabular-nums" }
const _hoisted_5 = { class: "flex-1 min-w-0" }
const _hoisted_6 = { class: "text-base font-medium text-stone-800 dark:text-stone-200 group-hover:text-stone-900 dark:group-hover:text-stone-100 transition-colors" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-stone-600 dark:text-stone-400 font-normal" }
const _hoisted_10 = { class: "mt-2 text-sm text-stone-600 dark:text-stone-400 leading-relaxed" }
const _hoisted_11 = {
  key: 0,
  class: "mt-3 flex flex-wrap gap-2"
}

import CustomText from "@/components/common/CustomText.vue";
import { Experience } from "@/types/experienceType";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ExperienceList',
  props: {
    experience: {},
    useIcon: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const formatMonthYear = (value?: string) => {
  if (!value) return "Present";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Present";
  return new Intl.DateTimeFormat("en", {
    month: "short",
    year: "numeric",
  }).format(date);
};

const fromLabel = computed(() => formatMonthYear(props.experience?.from));
const toLabel = computed(() => formatMonthYear(props.experience?.to));

const techPills = computed(() => {
  return props.experience?.frameworks?.map((f) => f.name).filter(Boolean) || [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("time", _hoisted_4, _toDisplayString(fromLabel.value) + " — " + _toDisplayString(toLabel.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, [
          (__props.experience?.link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: __props.experience?.link,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "hover:underline underline-offset-4 decoration-stone-300 dark:decoration-stone-700"
              }, _toDisplayString(__props.experience?.jobTitle), 9, _hoisted_7))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.experience?.jobTitle), 1)),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-stone-400 dark:text-stone-600 mx-2" }, "·", -1)),
          _createElementVNode("span", _hoisted_9, _toDisplayString(__props.experience?.company), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(CustomText, {
            value: __props.experience?.description
          }, null, 8, ["value"])
        ]),
        (techPills.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(techPills.value, (tech) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: tech,
                  class: "inline-flex items-center px-3 py-1 rounded-full bg-stone-100 dark:bg-stone-800 text-xs font-medium text-stone-700 dark:text-stone-300"
                }, _toDisplayString(tech), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})